"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseController_1 = __importDefault(require("./BaseController"));
class CovidPersonApi extends BaseController_1.default {
    constructor() {
        super();
        this.fetchPerson = (mit_id) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_person}/${mit_id}`, yield this.requestHeaderGet());
            if (response.status == 200) {
                let data = yield response.json();
                return { item: data };
            }
            else {
                return {
                    error: true
                };
            }
        });
        this.url_person = `${this.apiHost}/${this.apiPathCovid}/person`;
    }
}
const covidPersonApi = new CovidPersonApi();
exports.default = covidPersonApi;
